(function (ws) {
    'use strict';

    ws.views.dataTable = Backbone.View.extend({

        /**
         * Initialize
         */
        initialize: function () {
            this.$table = this.$('table');
            this.tableOptions = this.$table.data();
            this.render();

            this.eventAgg.on('ws.views.dataTable:Destroy', this.destroy, this);
        },

        /**
         * Render
         */
        render: function () {

            // Define default options for table
            const tableOptions = {
                searching: false,
                lengthChange: true,
                dom: '<"top"iflp>rt<"bottom"iflp><"clear">',
                language: {
                    lengthMenu: 'Show <div class="select-style">_MENU_</div> Per Page',
                    oPaginate: {
                        sNext: '>',
                        sPrevious: '<'
                    }
                }
            };

            // Determine whether to show table info
            tableOptions.info = !_.isUndefined(this.tableOptions.info) ? this.tableOptions.info : true;

            // Determine whether to use paging
            tableOptions.paging = !_.isUndefined(this.tableOptions.paginate) ? this.tableOptions.paginate : true;

            // Determine whether to use sorting
            tableOptions.ordering = !_.isUndefined(this.tableOptions.sortable) ? this.tableOptions.sortable : false;

            // Determine whether to use responsive design;
            // if true, will make all columns that cannot be seen
            // due to window width as inline description
            // by clicking left-most column
            if (!_.isUndefined(this.tableOptions.responsive)) {
                tableOptions.responsive = {
                    details: {
                        type: 'inline',
                        target: 0
                    }
                };
                tableOptions.columnDefs = [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: -1 }
                ];
            }
            else {
                tableOptions.responsive = false;
            }

            // Render the table
            this.table = this.$table.dataTable(tableOptions);
        },

        /**
         * Destroy dataTable element
         */
        destroy: function() {
            this.$table.DataTable().destroy();
        }

    });
})(westcon);
